// @mui
import { Box } from '@mui/material';
// hooks
import useTenantMode from '../../hooks/useTenantMode';

// ----------------------------------------------------------------------

/**
 * Full-width color stripe signalling org vs. single-venue mode, rendered
 * at the DashboardLayout level (not inside the header) so it sits outside
 * the AppBar's `backdropFilter` — a filter/backdrop-filter on an ancestor
 * creates a new containing block for `position: fixed` descendants, which
 * would otherwise confine the stripe to the header's own (sidebar-offset)
 * width instead of the full viewport.
 */
export default function TenantModeStripe() {
  const { color } = useTenantMode();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        bgcolor: color,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        transition: (theme) => theme.transitions.create('background-color'),
      }}
    />
  );
}
